import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { PlatformService } from 'src/app/services/platformbase.service';
import { Title } from '@angular/platform-browser';
import { LoginModel } from 'src/app/models/Login/login.model';
import { AppConfig } from '../../config/app.config';
import { htmlValidator } from '../../validations/custom-validation';
import { ToastrService } from 'ngx-toastr';
import { MenuController, NavController } from '@ionic/angular';
import { CookieService } from "ngx-cookie-service";
import { ThemeService } from 'src/app/services/theme.service';
// import { Storage } from '@ionic/storage';
import { SharedService } from 'src/app/services/common-services/shared.service';
import { environment } from 'src/environments/environment';
import { EmailApprovalM } from 'src/app/models/Common/common.model';
import { InAppBrowserOptions, InAppBrowser } from "@ionic-native/in-app-browser/ngx";
import { CommonService } from 'src/app/services/common-services/common.service';
import { Keyboard } from '@ionic-native/keyboard/ngx';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ["./login.component.scss"],

})
export class LoginComponent implements OnInit, OnDestroy {

    loginForm: FormGroup;
    ssoLoginForm1: FormGroup;
    ssoLoginForm2: FormGroup;
    otpLoginForm1: FormGroup;
    otpLoginForm2: FormGroup;
    slider: any;
    submitted = false;
    buttonDisabled = false;
    slideOpts = {
        initialSlide: 0,
        slidesPerView: 1,
        autoplay: true
    };
    platformType: number;
    validationMsg: any;
    public expiredDate = new Date();
    loginModel = new LoginModel();
    ssoLogin: boolean = false;
    apiKey: string;

    showPassword = false;
    passwordToggleIcon = 'eye-close'
    applogo: any;
    pathlogo: any;
    userInfo: any;
    isPerDiemEnabled: any;
    ssoToken: any;
    favIcon = './assets/images/Logo-EP.svg';
    passwordVisible = false;
    isAndroidIOS: any;
    appLogo: any;
    showSSOForm1 = false;
    showSSOForm2 = false;
    showOTPForm1 = false;
    showOTPForm2 = false;
    domainName: any;
    footerTitle: any;
    loginVerify: boolean = false;
    loginType: any;
    otpEmail: string = '';
    otpTimer: number = 0;
    otpTimerInterval: any; 
    ssoRedirectName: string;
    constructor(

        private formBuilder: FormBuilder,
        private platformService: PlatformService,
        private authenticationService: AuthenticationService,
        private title: Title,
        public toaster: ToastrService,
        public router: NavController,
        public menuCtrl: MenuController,
        private cookieService: CookieService,
        private theme: ThemeService,
        // public storage: Storage,
        public sharedService: SharedService, private activeRouter: ActivatedRoute,
        private router1: Router,
        private theInAppBrowser: InAppBrowser,
        private commonService: CommonService,
        private keyboard: Keyboard
    ) {
        this.keyboard.disableScroll(true);
        this.commonService.getAppTheme().subscribe((res: any) => {
            this.pathlogo = res.company_logo;
            this.favIcon = res.favIcon;
            this.footerTitle = res.title;
            const favIcon = document.querySelector('#appIcon') as HTMLLinkElement;
            favIcon.href = this.favIcon;
            this.title.setTitle(`Login`);
        });
        if (this.router1.url.includes('/ssoLogin/')) {
            this.ssoLogin = true;
            const ssoLoginParams = this.getSSOLoginParams();
            this.apiKey = ssoLoginParams.apiKey;
            this.ssoRedirectName = ssoLoginParams.redirectName;
            this.loginModel.token = this.apiKey;
            this.formSubmit();
        }
        if (this.router1.url.includes('/nessoLogin/')) {
            this.ssoLogin = true;
            this.ssoToken = this.activeRouter.snapshot.params['ssoToken'];
            this.loginModel.ssoToken = this.ssoToken;
            this.formSubmit();
        }
        // console.log('router url :', this.router1);
        // if (this.router1.url.includes('/emailApproval/')) {
        //     console.log('return value is :', this.activeRouter.snapshot.params['ssoToken']);
        //     this.loginModel.ssoToken = this.activeRouter.snapshot.params['ssoToken'];
        //     let email_model = new EmailApprovalM();
        //     email_model.claimId = this.activeRouter.snapshot.params['claimId'];
        //     email_model.claimGUID = this.activeRouter.snapshot.params['claimGUID'];
        //     email_model.roleId = this.activeRouter.snapshot.params['roleId'];
        //     email_model.userId = this.activeRouter.snapshot.params['userId'];
        //     email_model.userGuid = this.activeRouter.snapshot.params['userGuid'];
        //     this.sharedService.setEmailApprovalInfo(email_model);
        //     this.buttonDisabled = true;
        //     this.emailApprovalformSubmit();
        // }

        this.submitted = false;
        this.slider = {
            isBeginningSlide: true,
            isEndSlide: false,
            slidesItems: [
                {
                    description: "70% of corporates use emails for business travel bookings. Eva is an email bot which automates travel bookings by email."
                },
                {
                    description: "Eva reads & understands the email requests using AI. The more Eva is used, the smarter it becomes and gives personalised travel options."
                },
                {
                    description: "Eva is more than an email bot. Eva comes with a web-based Self Booking Tool which seamlessly integrates with other travel ERPs."
                }
            ]
        };
    }

    ionViewWillEnter() {
        this.menuCtrl.enable(false);
        this.submitted = false;
        this.buttonDisabled = false;
        this.loginForm.reset();
        this.showOTPForm1 = false;
        this.showOTPForm2 = false;
        this.stopOTPTimer();
        // sessionStorage.clear();
        // this.storage.clear();
    }

    ngOnInit() {
        this.appLogo = environment.appLogo;
        if (environment.appLogo == "expenses") {
            this.applogo = "noexp";
        } else if (environment.appLogo == "fc365") {
            this.applogo = "FC365logo";
            this.pathlogo = './assets/svg/FC365logo.svg';
        } else {
            this.applogo = "noexp";
        }
        if(environment.Default_SSOLogin == true) this.loginWithSSO()

        this.validationMsg = AppConfig;
        this.platformType = this.platformService.getPlatformType();
        this.isAndroidIOS = this.platformService.isAndroidIOS();

        if(this.isAndroidIOS != 2){
            this.loginVerify = true;
        }
        this.loginForm = this.formBuilder.group({
            email: ['', [Validators.required, Validators.email, htmlValidator]],
            password: ['', [Validators.required]],
            rememberMe: ['']
        });
        this.ssoLoginForm1 = this.formBuilder.group({
            email: ['', [Validators.required, Validators.email, htmlValidator]],
            // action: ['ssouser']
        });
        this.ssoLoginForm2 = this.formBuilder.group({
            email: ['', [Validators.required]],
            password: ['', [Validators.required]],
            domain: ['rane'],
            action: [''],
        });
        this.otpLoginForm1 = this.formBuilder.group({
            email: ['', [Validators.required, Validators.email, htmlValidator]],
        });
        this.otpLoginForm2 = this.formBuilder.group({
            otp1: ['', [Validators.required, Validators.pattern(/^[0-9]$/)]],
            otp2: ['', [Validators.required, Validators.pattern(/^[0-9]$/)]],
            otp3: ['', [Validators.required, Validators.pattern(/^[0-9]$/)]],
            otp4: ['', [Validators.required, Validators.pattern(/^[0-9]$/)]],
        });

        if (this.cookieService.check("remember")) {
            this.loginForm.patchValue({
                email: this.cookieService.get("email"),
                rememberMe: Boolean(this.cookieService.get("remember"))
            });
        }

    }

    get f() {
        return this.loginForm.controls;
    }

    get sf1() {
        return this.ssoLoginForm1.controls;
    }
    get sf2() {
        return this.ssoLoginForm2.controls;
    }
    get of1() {
        return this.otpLoginForm1.controls;
    }
    get of2() {
        return this.otpLoginForm2.controls;
    }
    refreshPage(event) {

        setTimeout(() => {
            event.target.complete();
            this.submitted = false;
            this.buttonDisabled = false
            this.loginForm.reset();
        }, 2000);

    }

    ssoForm1Submit() {
        this.submitted = true;
        if (!this.ssoLoginForm1.valid) {
            return;
        }
        this.buttonDisabled = true;
         
        if(!this.loginVerify){
  
            // obj.email = this.commonService.encryptData((this.loginModel.email)?.toString());
            // obj.password = this.commonService.encryptData((this.loginModel.password)?.toString());
            // obj.domain = "eva"
            this.authenticationService.verifyEvaUser(this.ssoLoginForm1.value).subscribe(res => {
                if (!res.isError && res.errorCode === 0 && res.payload) {
                    if(res.payload == "TRAVEL"){
                        this.loginType = "TRAVEL";
                        this.loginVerify = true;
                        this.buttonDisabled = false;
                        this.getSSOUrl();
                    }else if(res.payload == "EXPENSES"){
                        this.loginType = "EXPENSES";
                        this.loginVerify = true;
                        this.buttonDisabled = false;
                        this.getSSOUrl();
                    }else if(res.payload == "RANEEVA") {
                        this.submitted = false;
                        this.loginVerify = true;
                        this.showSSOForm2 = true;
                        this.showSSOForm1 = false;
                        this.buttonDisabled = false;
                        this.ssoLoginForm2.controls.action.patchValue(res.payload);
                    }else{
                        this.loginVerify = false;
                        this.buttonDisabled = false;
                    }
                
                }else{
                    this.buttonDisabled = false;
                    this.toaster.error(res.errorMessage, 'Error');
                }

            }, (error) => {
                this.buttonDisabled = false;
            });
        }

        if(this.loginVerify){
            if (environment.appLogo == "fc365-travel" || this.loginType == "TRAVEL") {
                this.getSSOUrl();
            }
            else{
                this.authenticationService.authenticateUser(this.ssoLoginForm1.value).subscribe(res => {
                    if (!res.isError && res.errorCode === 0 && res.payload) {
                        if(res?.payload?.maintenanceCode == 1 || res?.payload?.maintenanceCode == 2) {
                            this.sharedService.setMaintenanceflag(true);
                        }
                        this.domainName = res?.payload?.ssoCode;
                        this.buttonDisabled = false;
                        if(this.domainName == 'RANEEVA') {
                            this.showSSOForm2 = true;
                            this.showSSOForm1 = false;
                            this.submitted = false;
                            this.ssoLoginForm2.controls.action.patchValue(res.payload?.ssoCode);
                        } else {
                            this.getSSOUrl();
                        }
                    } else if (res.isError) {
                        this.buttonDisabled = false;
                        this.toaster.error(res.errorMessage, 'Error');
                    }
                }, err => {
                    this.buttonDisabled = false;
                });
            }
        }
      
    }

    ssoForm2Submit() {
        this.submitted = true;
        if (!this.ssoLoginForm2.valid) {
            return;
        }
        this.buttonDisabled = true;
        this.authenticationService.authenticateEvaUser(this.ssoLoginForm2.value).subscribe(res => {
            if (!res.isError && res.errorCode === 0 && res.payload) {
                this.ssoLogin = true;
                this.loginModel.action = 'ssouser';
                this.loginModel.ssoToken = res.payload;
                this.formSubmit();

            } else if (res.isError) {
                this.buttonDisabled = false;
                this.toaster.error(res.errorMessage, 'Error');
            }
        }, err => {
            this.buttonDisabled = false;
        });
    }

    getSSOUrl() {
        let obj = {
            email: this.ssoLoginForm1.controls.email.value,
            domain: ((environment.appLogo == "fc365" || environment.appLogo == "fc365-travel" ) && this.isAndroidIOS == 2) ? 'eva' : 'expenses'
        }
        this.authenticationService.getSSOurl(obj).subscribe(res => {
            if (!res.isError && res.errorCode == 0 && res.payload) {
                if (this.isAndroidIOS == 2) {
                    // Use InAppBrowser with '_blank' for new-page navigation
                    let ref = this.theInAppBrowser.create(res.payload.url, '_blank', 'location=yes');
                    ref.on('loadstop').subscribe((event: any) => {
                        if (event.url.indexOf('ssoLogin') >= 0) {
                            var final = event.url.substring(event.url.lastIndexOf('/') + 1);
                            sessionStorage.setItem("SSO", final);
                            sessionStorage.setItem("SSOCalling", "false");
                            ref.close();
                        } else if (event.url.indexOf('air') >= 0 || event.url.indexOf('home') >= 0) {
                            sessionStorage.removeItem('SSO');
                            sessionStorage.setItem("SSOCalling", "true");
                            ref.close();
                        } else {
                            sessionStorage.removeItem('SSO');
                            sessionStorage.setItem("SSOCalling", "false");
                            ref.show();
                        }
                    });
                } else {
                    // For web browsers, navigate in the same page
                    window.location.href = res.payload.url;
                }

                const timer = setInterval(() => {
                    if (sessionStorage.getItem('SSO')) {
                        clearInterval(timer);
                        this.ssoLogin = true;
                        this.loginModel.action = 'ssouser';
                        this.loginModel.ssoToken = sessionStorage.getItem('SSO');
                        this.formSubmit();
                    }
                    if (sessionStorage.getItem("SSOCalling") == "true") {
                        clearInterval(timer);
                        this.getSSOUrl();
                    }
                }, 1000);
            } else if (res.isError) {
                this.buttonDisabled = false;
                this.toaster.error(res.errorMessage, 'Error');
            }
        }, err => {
            this.buttonDisabled = false;
            this.toaster.error(err.errorMessage, 'Error');
        });
    }

    loginWithSSO() {
        this.submitted = false;
        this.showSSOForm1 = true;
        this.showSSOForm2 = false;
        this.showOTPForm1 = false;
        this.showOTPForm2 = false;
        this.loginVerify = false;
        this.stopOTPTimer();
    }

    loginWithPswrd() {
        this.submitted = false;
        this.showSSOForm1 = false;
        this.showSSOForm2 = false;
        this.showOTPForm1 = false;
        this.showOTPForm2 = false;
    }

    loginWithOTP() {
        this.submitted = false;
        this.showSSOForm1 = false;
        this.showSSOForm2 = false;
        this.showOTPForm1 = true;
        this.showOTPForm2 = false;
        this.otpLoginForm1.reset();
        this.otpLoginForm2.reset();
        this.otpEmail = '';
        this.stopOTPTimer();
    }

    otpForm1Submit() {
        this.submitted = true;
        if (!this.otpLoginForm1.valid) {
            return;
        }
        this.buttonDisabled = true;
        this.otpEmail = this.otpLoginForm1.controls.email.value;

        let obj = {
            email: this.otpEmail,
            action: "send-otp",
            domain: "expenses"
        };

        this.authenticationService.sendLoginOTP(obj).subscribe(res => {
            if (!res.isError && res.errorCode === 0) {
                this.showOTPForm1 = false;
                this.showOTPForm2 = true;
                this.submitted = false;
                this.buttonDisabled = false;
                this.startOTPTimer();
                this.toaster.success('OTP sent to your email', 'Success');
            } else {
                this.buttonDisabled = false;
                this.toaster.error(res.errorMessage || 'Failed to send OTP', 'Error');
            }
        }, (error) => {
            this.buttonDisabled = false;
            this.toaster.error('Failed to send OTP', 'Error');
        });
    }

    otpForm2Submit() {
        this.submitted = true;
        if (!this.otpLoginForm2.valid) {
            return;
        }
        this.buttonDisabled = true;
        
        const otp = this.otpLoginForm2.controls.otp1.value + 
                   this.otpLoginForm2.controls.otp2.value + 
                   this.otpLoginForm2.controls.otp3.value + 
                   this.otpLoginForm2.controls.otp4.value;

        let obj = {
            email: this.commonService.encryptData(this.otpEmail),
            otp: otp
        };

        this.authenticationService.verifyLoginOTP(obj).subscribe(res => {
            if (!res.isError && res.errorCode === 0 && res.payload) {
                if(res?.payload?.maintenanceCode == 1 || res?.payload?.maintenanceCode == 2) {
                    this.sharedService.setMaintenanceflag(true);
                }
                sessionStorage.setItem("isAuthenticated", JSON.stringify(true));
                sessionStorage.setItem("isAttachmentMandatory", JSON.stringify(res?.payload?.isAttachmentMandatory));
                sessionStorage.setItem("userInfo", JSON.stringify(res.payload));
                localStorage.setItem("userInfo", JSON.stringify(res.payload));
                this.menuCtrl.enable(true, 'mainMenu');
                this.menuCtrl.enable(false, 'settingMenu');
                this.buttonDisabled = false;
                this.stopOTPTimer();
                sessionStorage.setItem("current-lang", res.payload.baseLanguage);
                this.authenticationService.status.next(true);
                this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
                this.getperdiemstatus(this.userInfo);

                const themeObj = {
                    primary: res.payload.primaryColor,
                    secondary: res.payload.secondaryColor,
                    fontFamily: res.payload.font
                };
                sessionStorage.setItem('theme', JSON.stringify(themeObj));
                this.theme.applyTheme(themeObj);
                
                if (res.payload.forceChangePassword) {
                    this.router.navigateRoot(['changepassword']);
                } else {
                    if (this.isAndroidIOS == 1) {
                        this.router.navigateRoot(['dashboard']);
                    } else if (this.isAndroidIOS == 2) {
                        sessionStorage.setItem("isadmin", JSON.stringify(false));
                        this.sharedService.setUserToggle(!false);
                        if (environment.appLogo == "fc365") {
                            let fc365Obj = res.payload.appsUrl;
                            if (fc365Obj) {
                                let obj365url = fc365Obj[0].value;
                                localStorage.setItem('fc365', JSON.stringify(true));
                                localStorage.setItem('fc365url', JSON.stringify(obj365url));
                                
                                let AppType = 1;
                                const hasTravel = res.payload.appsUrl?.some(item => item.key === "Travel" && item.value !== null);
                                const hasExpenses = true;

                                if (hasTravel && hasExpenses) {
                                    AppType = 1;
                                } else if (hasTravel && !hasExpenses) {
                                    AppType = 2;
                                } else if (!hasTravel && hasExpenses) {
                                    AppType = 3;
                                }

                                let DefaultApp = res.payload?.defaultApp ? res.payload?.defaultApp : 'expenses';

                                if(AppType == 1) {
                                    if(DefaultApp == 'travel') {
                                        this.router.navigateRoot(['traveleva']);
                                    } else {
                                        this.router.navigateRoot(['dashboard']);
                                    }
                                } else if(AppType == 2) {
                                    this.router.navigateRoot(['traveleva']);
                                } else if(AppType == 3) {
                                    this.router.navigateRoot(['dashboard']);
                                }
                            } else {
                                this.router.navigateRoot(['dashboard']);
                            }
                        } else {
                            this.router.navigateRoot(['dashboard']);
                        }
                        this.sharedService.setUserInfo(true);
                    }
                }
            } else {
                this.buttonDisabled = false;
                this.toaster.error(res.errorMessage || 'Invalid OTP', 'Error');
            }
        }, (error) => {
            this.buttonDisabled = false;
            this.toaster.error('Failed to verify OTP', 'Error');
        });
    }

    startOTPTimer() {
        this.otpTimer = 60;
        this.otpTimerInterval = setInterval(() => {
            if (this.otpTimer > 0) {
                this.otpTimer--;
            } else {
                this.stopOTPTimer();
            }
        }, 1000);
    }

    stopOTPTimer() {
        if (this.otpTimerInterval) {
            clearInterval(this.otpTimerInterval);
            this.otpTimerInterval = null;
        }
        this.otpTimer = 0;
    }

    resendOTP() {
        if (this.otpTimer > 0) {
            return;
        }
        this.otpForm1Submit();
    }

    onOTPInput(event: any, nextInput: number) {
        const input = event.target;
        let value = input.value;
        
        // Only allow numbers
        value = value.replace(/[^0-9]/g, '');
        
        // Limit to single digit
        if (value.length > 1) {
            value = value.slice(-1);
        }
        
        input.value = value;
        
        // Update form control
        const controlName = `otp${nextInput - 1}`;
        this.otpLoginForm2.get(controlName)?.setValue(value, { emitEvent: false });
        
        if (value && value.length === 1 && /^[0-9]$/.test(value)) {
            if (nextInput <= 4) {
                const nextElement = document.getElementById(`otp${nextInput}`);
                if (nextElement) {
                    nextElement.focus();
                }
            }
        }
    }

    onOTPKeyDown(event: KeyboardEvent, currentInput: number) {
        if (event.key === 'Backspace') {
            const input = event.target as HTMLInputElement;
            if (!input.value && currentInput > 1) {
                const prevElement = document.getElementById(`otp${currentInput - 1}`);
                if (prevElement) {
                    prevElement.focus();
                }
            }
        }
    }

    disableCopyPaste(event: Event) {
        if (environment.appLogo == "fc365" && this.platformService.isMobileDevice()) {
            event.preventDefault();
        }
    }

    private getSSOLoginParams() {
        const snapshotApiKey = this.activeRouter.snapshot.params['apiKey'];
        const apiKeyQueryName = this.getQueryValueFromUrl('name', snapshotApiKey);
        const cleanApiKey = snapshotApiKey ? snapshotApiKey.split('?')[0] : snapshotApiKey;
        const redirectName = this.getSSORedirectName(apiKeyQueryName);

        return {
            apiKey: cleanApiKey,
            redirectName: redirectName
        };
    }

    private getSSORedirectName(apiKeyQueryName?: string) {
        const snapshotName = this.activeRouter.snapshot.queryParamMap.get('name') || this.activeRouter.snapshot.queryParams?.name;
        const snapshotRedirectName = this.activeRouter.snapshot.params['redirectName'];
        const routerName = this.router1.parseUrl(this.router1.url).queryParams?.name;
        const routerUrlName = this.getQueryValueFromUrl('name', this.router1.url);
        const routerStateName = this.getQueryValueFromUrl('name', this.activeRouter.snapshot['_routerState']?.url);
        const locationSearchName = typeof window !== 'undefined' ? new URLSearchParams(window.location.search).get('name') : null;
        const locationHrefName = this.getQueryValueFromUrl('name', typeof window !== 'undefined' ? window.location.href : '');
        const performanceUrl = this.getNavigationUrl();
        const performanceUrlName = this.getQueryValueFromUrl('name', performanceUrl);

        return snapshotName || snapshotRedirectName || routerName || routerUrlName || routerStateName || locationSearchName || locationHrefName || performanceUrlName || apiKeyQueryName || null;
    }

    private getNavigationUrl() {
        if (typeof window === 'undefined' || !window.performance?.getEntriesByType) {
            return null;
        }

        const navigationEntry = window.performance.getEntriesByType('navigation')?.[0] as PerformanceNavigationTiming;
        return navigationEntry?.name || null;
    }

    private getQueryValueFromUrl(key: string, url: string) {
        if (!url) {
            return null;
        }

        const match = decodeURIComponent(url).match(new RegExp(`[?&]${key}=([^&#]*)`));
        return match ? match[1].replace(/\+/g, ' ') : null;
    }

    private getSSOClaimRedirectData() {
        const redirectName = (this.ssoRedirectName || this.getSSORedirectName() || '').replace(/\+/g, ' ').trim().toLowerCase();
        const statusMap = {
            pending: { label: 'Pending', ids: [2] },
            approved: { label: 'Approved', ids: [3, 6, 7] },
            rejected: { label: 'Rejected', ids: [4, 5] },
            'sent back': { label: 'Sent Back', ids: [11] }
        };

        const status = statusMap[redirectName];
        if (!status) {
            return null;
        }

        return {
            from: 'dashboardFilter',
            label: status.label,
            name: redirectName,
            ids: status.ids,
            fromDate: undefined,
            toDate: undefined
        };
    }

    formSubmit() {
        this.submitted = true;
        if (this.ssoLogin) {
            this.loginModel.email = null;
            this.loginModel.password = null;

            // this.loginModel.token = 'oQnFxDTW4iqd--zwfCOmNfkWptY14D--qFPfN7q5uo9j6OwlRqLRt--EqSOGG4cZ+4SQGd5cDgQtKj2c3f4BuH1nynHUiA2Xf5rUpn0Za2TRRN0MrmHyfpjkdnjlNmYlBWWyeBA5pIETYJLr2viEsMiHYmrhjoLgXITjAioIQZHQq0='
        } else {
            if (!this.loginForm.valid && this.loginVerify) {
                return;
            }
            if (!this.loginVerify && ((this.loginModel.email)?.toString() == '') || ((this.loginModel.email)?.toString() == undefined)) {
                return;
            }
        }
        this.buttonDisabled = true;
        let obj = JSON.parse(JSON.stringify({ ...this.loginModel }));

        if(!this.loginVerify){
  
            obj.email = this.commonService.encryptData((this.loginModel.email)?.toString());
            // obj.password = this.commonService.encryptData((this.loginModel.password)?.toString());
            // obj.domain = "eva"
            this.authenticationService.verifyEvaUser(obj).subscribe(res => {
                if (!res.isError && res.errorCode === 0 && res.payload) {
                    if(res.payload == "TRAVEL"){
                        this.loginType = "TRAVEL";
                        this.loginVerify = true;
                        this.buttonDisabled = false;
                    }else if(res.payload == "EXPENSES"){
                        this.loginType = "EXPENSES";
                        this.loginVerify = true;
                        this.buttonDisabled = false;
                    }else if(res.payload == "RANEEVA") {
                        this.submitted = false;
                        this.loginVerify = true;
                        this.showSSOForm2 = true;
                        this.showSSOForm1 = false;
                        this.buttonDisabled = false;
                        this.ssoLoginForm2.controls.action.patchValue(res.payload);
                    }else{
                        this.loginVerify = false;
                        this.buttonDisabled = false;
                    }
                    this.submitted = false;
                
                }else{
                    this.buttonDisabled = false;
                    this.toaster.error(res.errorMessage, 'Error');
                }

            }, (error) => {
                this.buttonDisabled = false;
            });
        }
        if(this.loginVerify  || this.ssoLogin){
            // if (!this.ssoLogin && environment.appLogo != "fc365-travel") {
            if (!this.ssoLogin){
                obj.email = this.commonService.encryptData((this.loginModel.email)?.toString());
                obj.password = this.commonService.encryptData((this.loginModel.password)?.toString());
                obj.isEncrypted = true;
            }
            if (environment.appLogo == "fc365-travel" || this.loginType == "TRAVEL") {
                // call EVA login API
                obj.email = this.commonService.encryptData((this.loginModel.email)?.toString());
                obj.password = this.commonService.encryptData((this.loginModel.password)?.toString());
                obj.domain = "eva"
                this.authenticationService.validateEvaUser(obj).subscribe(res => {
                    if (!res.isError && res.errorCode === 0 && res.payload) {
                        sessionStorage.setItem("isAuthenticated", JSON.stringify(true));
        
                        // localStorage.setItem("isAttachmentMandatory", JSON.stringify(res.payload.isAttachmentMandatory));
                        sessionStorage.setItem("userInfo", JSON.stringify(res.payload));
                        localStorage.setItem("userInfo", JSON.stringify(res.payload));
                        this.router.navigateRoot(['traveleva']); 
                    
                    }
                    else{
                        this.buttonDisabled = false;
                        this.toaster.error(res.errorMessage, 'Error');
                    }

                })
            } else {
            this.authenticationService.authenticateUser(obj).subscribe(res => {
                if (!res.isError && res.errorCode === 0 && res.payload) {
                    if(res?.payload?.maintenanceCode == 1 || res?.payload?.maintenanceCode == 2) {
                        this.sharedService.setMaintenanceflag(true);
                    }
                    sessionStorage.setItem("isAuthenticated", JSON.stringify(true));
                    sessionStorage.setItem("isAttachmentMandatory", JSON.stringify(res?.payload?.isAttachmentMandatory));
                    // localStorage.setItem("isAttachmentMandatory", JSON.stringify(res.payload.isAttachmentMandatory));
                    sessionStorage.setItem("userInfo", JSON.stringify(res.payload));
                    localStorage.setItem("userInfo", JSON.stringify(res.payload));
                    // this.sharedService.setUserInfo(true);
                    this.menuCtrl.enable(true, 'mainMenu');
                    this.menuCtrl.enable(false, 'settingMenu');
                    this.isRememberedMe();
                    this.buttonDisabled = false;
                    sessionStorage.setItem("current-lang", res.payload.baseLanguage);
                    this.authenticationService.status.next(true);
                    this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
                    this.getperdiemstatus(this.userInfo);

                    const obj = {
                        primary: res.payload.primaryColor,
                        secondary: res.payload.secondaryColor,
                        fontFamily: res.payload.font
                    };
                    sessionStorage.setItem('theme', JSON.stringify(obj));
                    this.theme.applyTheme(obj);
                    if (res.payload.forceChangePassword) {
                        this.router.navigateRoot(['changepassword']);
                    } else {
                        const ssoClaimRedirectData = this.getSSOClaimRedirectData();
                        if (ssoClaimRedirectData) {
                            sessionStorage.setItem("isadmin", JSON.stringify(false));
                            this.sharedService.setUserToggle(true);
                            this.sharedService.setUserInfo(true);
                            this.router1.navigate(['/expenses'], { state: { data: ssoClaimRedirectData } });
                            return;
                        }
                        //this.router.navigateRoot(['dashboard']);
                        // console.log('isAndroidIOS _________ ', this.isAndroidIOS);
                        if (this.isAndroidIOS == 1) {
                            this.router.navigateRoot(['dashboard']);
                        } else if (this.isAndroidIOS == 2) {
                            sessionStorage.setItem("isadmin", JSON.stringify(false));
                            this.sharedService.setUserToggle(!false);
                            // this.router.navigateRoot(['camera']); //murthySir changes
                            if (environment.appLogo == "fc365") {
                                let fc365Obj = res.payload.appsUrl;
                                if (fc365Obj) {
                                    let obj365url = fc365Obj[0].value;
                                    localStorage.setItem('fc365', JSON.stringify(true));
                                    localStorage.setItem('fc365url', JSON.stringify(obj365url));
                                    
                                    let AppType = 1;
                                    // const modules = res.payload.appsUrl || [];

                                    // Check if Travel exists
                                    const hasTravel = res.payload.appsUrl?.some(item => item.key === "Travel" && item.value !== null);

                                    // Check if Expenses exists
                                    const hasExpenses = true; //res.payload.appsUrl?.some(item => item.key === "Expenses" && item.value !== null);

                                    // Set AppType based on conditions
                                    if (hasTravel && hasExpenses) {
                                    AppType = 1; // Both Travel and Expenses
                                    } else if (hasTravel && !hasExpenses) {
                                    AppType = 2; // Only Travel
                                    } else if (!hasTravel && hasExpenses) {
                                    AppType = 3; // Only Expenses
                                    }


                                    let DefaultApp = res.payload?.defaultApp ? res.payload?.defaultApp :  'expenses'

                                    if(AppType == 1) {
                                        if(DefaultApp == 'travel') {
                                            this.router.navigateRoot(['traveleva']);
                                        }else {
                                            this.router.navigateRoot(['dashboard']);
                                        }
                                        // this.router.navigateRoot(['dashboardfc365']);
                                    }else if(AppType == 2) {
                                        this.router.navigateRoot(['traveleva']);
                                    }else if(AppType == 3) {
                                        this.router.navigateRoot(['dashboard']);
                                    }

                                    // let obj365url = fc365Obj[0].value;
                                    // localStorage.setItem('fc365', JSON.stringify(true));
                                    // localStorage.setItem('fc365url', JSON.stringify(obj365url));
                                    // this.router.navigateRoot(['dashboardfc365']);
                                } else {
                                    this.router.navigateRoot(['dashboard']);
                                }
                            } else {
                                this.router.navigateRoot(['dashboard']);
                            }

                            this.sharedService.setUserInfo(true);

                        }
                    }
                } else if (res.isError && res.errorCode === 2) {
                    this.buttonDisabled = false;
                    this.toaster.error(res.errorMessage, 'Error');
                }
            });
            }
        }


       
    }

    // emailApprovalformSubmit() {
    //     this.buttonDisabled = true;
    //     this.authenticationService.authenticateUser(this.loginModel).subscribe(res => {
    //         if (!res.isError && res.errorCode === 0 && res.payload) {
    //             sessionStorage.setItem("isAuthenticated", JSON.stringify(true));
    //             sessionStorage.setItem("isAttachmentMandatory", JSON.stringify(res.payload.isAttachmentMandatory));
    //             sessionStorage.setItem("userInfo", JSON.stringify(res.payload));
    //             localStorage.setItem("userInfo", JSON.stringify(res.payload));
    //             sessionStorage.setItem("mainheadehidden",JSON.stringify(true));
                
    //             this.menuCtrl.enable(true, 'mainMenu');
    //             this.menuCtrl.enable(false, 'settingMenu');
    //             this.isRememberedMe();
    //             this.buttonDisabled = false;
    //             sessionStorage.setItem("current-lang", res.payload.baseLanguage);
    //             this.authenticationService.status.next(true);
    //             this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    //             this.getperdiemstatus(this.userInfo);

    //             const obj = {
    //                 primary: res.payload.primaryColor,
    //                 secondary: res.payload.secondaryColor,
    //                 fontFamily: res.payload.font
    //             };
    //             sessionStorage.setItem('theme', JSON.stringify(obj));
    //             this.theme.applyTheme(obj);
    //             sessionStorage.setItem("isEmailApproval", JSON.stringify(true));
    //             this.router.navigateRoot(['approvals']);
    //         } else if (res.isError && res.errorCode === 2) {
    //             this.buttonDisabled = false;
    //             this.toaster.error(res.errorMessage, 'Error');
    //         }
    //     });
    // }

    getperdiemstatus(item) {
        const requestObj = {
            "legalEntityId": item.legalEntityId,
            "legalEntityGUID": item.legalEntityGuId,
        }
        this.authenticationService.getUserConfiguration(JSON.stringify(requestObj)).subscribe(data => {
            if (data.errorCode == 0) {
                sessionStorage.setItem("isPerDiemEnabled", JSON.stringify(data.payload));
            }
        });
        this.commonService.fetchAndStoreCompanyConfigurations(item);
    }

    // Function for Remember Me Check Box
    isRememberedMe() {
        if (this.loginForm.controls?.rememberMe?.value) {
            this.expiredDate.setDate(this.expiredDate.getDate() + 10);
            this.cookieService.set("email", this.loginForm.controls.email?.value, this.expiredDate);
            this.cookieService.set("remember", String(this.loginForm.controls.rememberMe?.value), this.expiredDate);
        } else {
            this.cookieService.delete("email");
            this.cookieService.delete("remember");
        }
    }

    showPwd() {

    }

    navigateToSignup() {
        this.router.navigateRoot(['signup']);
    }

    returnForgot() {
        this.router.navigateRoot(['forgotpassword']);
    }

    togglePassword() {
        if (this.loginModel.password == '' || this.loginModel.password == null) {
        } else {
            this.showPassword = !this.showPassword;
            if (this.passwordToggleIcon == 'eye-close') {
                this.passwordToggleIcon = 'eye-open'
            } else {
                this.passwordToggleIcon = 'eye-close'
            }
        }
    }

    ngOnDestroy() {
        this.stopOTPTimer();
    }

}
